import { render } from "./SectionConnection.vue?vue&type=template&id=8bb1bc2a&scoped=true"
import script from "./SectionConnection.vue?vue&type=script&lang=js"
export * from "./SectionConnection.vue?vue&type=script&lang=js"

import "./SectionConnection.vue?vue&type=style&index=0&id=8bb1bc2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb1bc2a"]])

export default __exports__